import { checkForAffected } from '../../api/bundles/check-for-affected';
import { getActiveMaterials } from '../../api/bundles/get-active-materials';
import { getBundlesContainingMaterial } from '../../api/bundles/get-bundles-containing-material';
import { getBundlesSuggested } from '../../api/bundles/get-bundles-suggested';
import { getBundlesSuggestions } from '../../api/bundles/get-bundles-suggestions';
import { getMaterialsInBundle } from '../../api/bundles/get-materials-in-bundle';
import { saveBasicInfo } from '../../api/bundles/save-basic-info';
import { saveMaterialsList } from '../../api/bundles/save-materials-list';
import { setCover } from '../../api/bundles/set-cover';
import { uploadCoverRequest } from '../../api/bundles/upload-cover';
import { saveMaterialPrice } from '../../api/materials/save-material-price';
import formatPriceToFloat from '../../utils/price/format-price-to-float';

type SaveBundlePriceArgs = {
    bundleId: number | string;
    price: Price;
};

const bundleService = {
    checkForAffected,
    getActiveMaterials,
    getBundlesContainingMaterial,
    getMaterialsInBundle,
    notificationActions: {
        deactivation: 'deactivation',
        deletion: 'deletion',
        price: 'newPrice',
        sale: 'newPrice'
    },
    saveBasicInfo,
    saveCoverInfo: () =>
        new Promise<void>((resolve) => {
            resolve();
        }),
    saveMaterialsList,
    savePrice: ({ bundleId, price }: SaveBundlePriceArgs) =>
        saveMaterialPrice({ materialId: Number(bundleId), price: formatPriceToFloat(price) }),
    setCover,
    uploadCover: (files: File[], params: { bundle_id?: number | string; set_as_cover?: number | string } = {}) => {
        const file = files[0];

        return new Promise((resolve, reject) => {
            uploadCoverRequest(file, params).then(resolve, () => {
                reject(new Error('An error occured'));
            });
        });
    },
    getBundlesSuggestions,
    getBundlesSuggested
};

export default bundleService;
